module.exports = __webpack_public_path__ + "static/media/raise-or-fold1.2f38a8ca.png";